module.exports = __webpack_public_path__ + "resources/img/bg_cover_pricing_v2.32e28fd591127c3c996120ab03d91a79.png";